import React, { createContext } from "react";
import mitt from "mitt";

const eventEmitter = mitt();
const BusContext = createContext(null);

function EventProvider({ children }) {
  return (
    <BusContext.Provider value={eventEmitter}>{children}</BusContext.Provider>
  );
}

export default EventProvider;
export { eventEmitter, EventProvider };
